export const BRAZILIAN_STATES = [
  'AC',
  'AL',
  'AM',
  'AP',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MG',
  'MS',
  'MT',
  'PA',
  'PB',
  'PE',
  'PI',
  'PR',
  'RJ',
  'RN',
  'RO',
  'RR',
  'RS',
  'SC',
  'SE',
  'SP',
  'TO',
]

export const CNH_CATEGORIES = ['A', 'B', 'AB', 'C', 'D', 'E', 'AC', 'AD', 'AE']

export const CNPJ_NEW_DRIVER = '31.665.008/0001-09'

export const STATES_WITH_MUNICIPIO = ['MG', 'MA', 'GO', 'MS']

export const COURSE_CATEGORIES = [
  { label: 'Reciclagem', value: 'Curso de Reciclagem' },
  { label: 'Especialização', value: 'Curso de Especialização' },
  { label: 'Atualização', value: 'Curso de Atualização' },
  { label: 'Cursos Livres', value: 'Curso Livre' },
  { label: 'Cursos Livres de Atualização', value: 'Curso de Atualização Livre' },
]

// Cobre todos os valores de STATUS_MATRICULA que existem no banco. Antes só três estavam mapeados,
// e uma matrícula em AGUARDANDO_ENVIO (por exemplo) aparecia com a tag vazia.
export const STATUS_LABELS: Record<string, string> = {
  AGUARDANDO_PAGAMENTO: 'Aguardando Pagamento',
  AGUARDANDO_MATRICULA: 'Aguardando Matrícula',
  MATRICULANDO: 'Matriculando',
  MATRICULADO: 'Matriculado',
  AGUARDANDO_MATRICULA_MODULO_PRATICO: 'Aguardando Matrícula (Prático)',
  AGUARDANDO_CONCLUSAO_MODULO_PRATICO: 'Aguardando Conclusão (Prático)',
  AGUARDANDO_ENVIO: 'Aguardando Envio ao DETRAN',
  FINALIZADO: 'Finalizado',
  CANCELADO: 'Cancelado',
}

export const STATUS_COLORS: Record<string, string> = {
  AGUARDANDO_PAGAMENTO: '#f00000',
  AGUARDANDO_MATRICULA: '#d46b08',
  MATRICULANDO: '#d46b08',
  MATRICULADO: '#1900ff',
  AGUARDANDO_MATRICULA_MODULO_PRATICO: '#d46b08',
  AGUARDANDO_CONCLUSAO_MODULO_PRATICO: '#d46b08',
  AGUARDANDO_ENVIO: '#d46b08',
  FINALIZADO: '#03bb2e',
  CANCELADO: '#8c8c8c',
}
